<div class="programers_content">
    <h1 class="title">
        Programmes
        <div class="d-flex justify-content-center">
            <img src="../../../assets/img/new-kidzee/bottom_img.png" class="bottom_img" alt="">
        </div>
    </h1>
    <div class="img_txt_list boysImg_mobileView">
        <div class="row">
            <div class="col-md-3">
                <div class="card">
                    <div class="card_img">
                        <img src="../../../assets/img/our_presence/play_group.JPG" width="100%" alt="PlayGroup">
                    </div>
                    <div class="list" id="subInfo">
                        <div class="programTitle">Playgroup</div>
                        
                        <ul class="programlist mt-2">
                            <li>Promoting positive peer social interaction</li>
                            <li>Opportunities for basic motor development</li>
                            <li>Exploration based learning</li>
                            <li>Math Readiness</li>
                            <li>Language Readiness</li>
                            <li>Promoting cognitive development</li>
                        </ul>
                    </div>
                </div>
            </div>
            <div class="col-md-3">
                <div class="card">
                    <div class="card_img">
                        <img src="../../../assets/img/our_presence/nursery.JPG" width="100%" alt="nursery">
                    </div>
                    <div class="list" id="subInfo">
                        <div class="programTitle">Nursery</div>
                        <ul class="programlist mt-2">
                            <li>Developing communication skills</li>
                            <li>Learning to expression through art and drama</li>
                            <li>Language Skill Development (Phonics Introduction)</li>
                            <li>Math Skill Development (Number Value)</li>
                            <li>Opportunities for advanced fine and gross motor development</li>
                            <li>Promoting cognitive development (Sorts using two attributes)</li>
                            <li>'Panchkosha' integrated</li>
                        </ul>
                    </div>
                </div>
            </div>
            <div class="col-md-3">
                <div class="card">
                    <div class="card_img">
                        <img src="../../../assets/img/our_presence/kindergarten.JPG" width="100%" alt="kindergarten">
                    </div>
                    <div class="list" id="subInfo">
                        <div class="programTitle">Kindergarten</div>
                        <ul class="programlist mt-2">
                            <li>Developing oral and written communication skills</li>
                            <li>English Readiness Programme</li>
                            <li>Math Operations</li>
                            <li>Personal, Social, and Emotional Growth</li>
                            <li>Promoting cognitive development (Sorts using multiple attributes)</li>
                            <li>Visual & Performance Art</li>
                            <li>'Panchkosha' integrated</li>
                        </ul>
                    </div>
                </div>
            </div>
            <div class="col-md-3">
                <div class="card">
                    <div class="card_img">
                        <img src="../../../assets/img/our_presence/daycare.JPG" width="100%" alt="daycare">
                    </div>
                    <div class="list" id="subInfo">
                        <div class="programTitle">Daycare</div>
                        <ul class="programlist mt-2">
                            <li>Freshen up</li>
                            <li>Lunch</li>
                            <li>Nap time</li>
                            <li>Indoor activities</li>
                            <li>Snacks</li>
                            <li>Outdoor Activities</li>

                        </ul>
                    </div>
                </div>
            </div>
        </div>
    </div>
</div>